<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.7294 10.5868L11.5168 7.25363C11.6076 7.20153 11.6635 7.10466 11.6635 7.00031C11.6635 6.89597 11.6076 6.7991 11.5168 6.74685L5.7294 3.41321C5.63859 3.36096 5.52679 3.36096 5.43598 3.41321C5.34516 3.46545 5.28926 3.56218 5.28926 3.66667V5.21861H0.293424C0.131454 5.21861 0 5.34974 0 5.5113V8.48846C0 8.65002 0.131454 8.78114 0.293424 8.78114H5.28941V10.3329C5.28941 10.4377 5.34531 10.5342 5.43612 10.5864C5.4816 10.6127 5.53222 10.6256 5.58283 10.6256C5.63345 10.6256 5.68407 10.6127 5.7294 10.5868Z" fill="currentColor"/>
    <path d="M11.8323 0H5.85397C5.692 0 5.56055 0.131122 5.56055 0.292682V1.17073C5.56055 1.33229 5.692 1.46341 5.85397 1.46341H11.8323C12.2185 1.46341 12.5323 1.77673 12.5323 2.1616V11.8384C12.5323 12.2234 12.2182 12.5366 11.8323 12.5366H5.85397C5.692 12.5366 5.56055 12.6677 5.56055 12.8293V13.7073C5.56055 13.8689 5.692 14 5.85397 14H11.8323C13.0275 14 13.9994 13.0302 13.9994 11.8384V2.16175C13.9994 0.969801 13.0273 0 11.8323 0Z" fill="currentColor"/>
  </svg>
</template>

<script>
export default {
name: "IconLeave"
}
</script>

<style scoped>

</style>